import { useQuery } from "@tanstack/react-query";
import { ClientConfigApi } from "../api/client-config-api";

export const clientConfigQueryKeys = {
  getClientConfig: () => ["clientConfig"],
};

export function useClientConfigQuery() {
  return useQuery({
    queryKey: clientConfigQueryKeys.getClientConfig(),
    queryFn: () => ClientConfigApi.getClientConfig(),
    refetchInterval: 30_000,
  });
}
